export default {"src":"/_next/static/media/emptyImage.ae557a19.svg","height":120,"width":120};